module.exports = __webpack_public_path__ + "static/img/partner_20.8dafb36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_20.png
// module id = wdW3
// module chunks = 0